import { gsap, CSSPlugin, EasePack } from 'gsap/all';

import './main.ts';

gsap.registerPlugin(CSSPlugin);
gsap.registerPlugin(EasePack);
